import { render } from "./OwnerRecord.vue?vue&type=template&id=a95c6d50&scoped=true"
import script from "./OwnerRecord.vue?vue&type=script&lang=js"
export * from "./OwnerRecord.vue?vue&type=script&lang=js"

import "./OwnerRecord.vue?vue&type=style&index=0&id=a95c6d50&scoped=true&lang=css"
import "./OwnerRecord.vue?vue&type=style&index=1&id=a95c6d50&lang=css"
import "./OwnerRecord.vue?vue&type=style&index=2&id=a95c6d50&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=a95c6d50&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95c6d50"]])

export default __exports__